// Native 'storage' events only fire in OTHER tabs, not the tab that made the change.
// Pages with their own DC dropdown call broadcastDCChange() after writing to sessionStorage
// so Layout.tsx can update its side menu immediately, in the same tab.
export const DC_CHANGE_EVENT = 'app:dcChanged';

export const broadcastDCChange = (dc: string) => {
    window.dispatchEvent(new CustomEvent(DC_CHANGE_EVENT, { detail: dc }));
};
